import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col, FormGroup, Row, Grid } from "react-bootstrap";
import Button from "../../../../components/common/button/Button";
import styles from "./CompanyPayment.scss";

class CompanyPayment extends Component {
  render() {
    const cards = _.get(this.props.user, "stripe.sources.data");
    const default_source = _.get(this.props.user, "stripe.default_source");

    const card = _.head(
      _.filter(cards, card => {
        return card.id === default_source;
      })
    );

    return (
      <section className={styles.section}>
        <div className={styles.content}>
          <h2 className={styles.title}>Credit Card Information</h2>

          <Grid className={styles.form}>
            <FormGroup className={styles.formGroup}>
              {card ? (
                <React.Fragment>
                  <Row className={styles.row}>
                    <Col xs={12} sm={5} className={styles.rowLeft}>
                      Payment Method
                    </Col>
                    <Col xs={12} sm={7} className={styles.rowRight}>
                      {card.brand} ending with {card.last4}
                    </Col>
                  </Row>

                  <Row className={styles.row}>
                    <Col xs={12} sm={5} className={styles.rowLeft}>
                      Name on Card
                    </Col>
                    <Col xs={12} sm={7} className={styles.rowRight}>
                      {card.name}
                    </Col>
                  </Row>

                  <Row className={styles.row}>
                    <Col xs={12} sm={5} className={styles.rowLeft}>
                      Expiration Date
                    </Col>
                    <Col xs={12} sm={7} className={styles.rowRight}>
                      {card.exp_month}/{card.exp_year}
                    </Col>
                  </Row>
                </React.Fragment>
              ) : (
                <div>
                  <p>
                    You do not have a credit card on file, so you will receive
                    invoices directly from The Second Shift.
                  </p>
                  <p>
                    Click Add New Card if you wish to pay by credit card instead
                    of invoice.
                  </p>
                </div>
              )}
            </FormGroup>

            <Link to="/company/payment/add">
              <Button
                isPrimary
                className={styles.rowButton}
                size={"large"}
                label="Add New Card"
              />
            </Link>
          </Grid>
        </div>
      </section>
    );
  }
}

export default CompanyPayment;



// WEBPACK FOOTER //
// ./src/routes/employer/payment/components/CompanyPayment.js